import { render, staticRenderFns } from "./CreateTenant.vue?vue&type=template&id=c03fa4e2&scoped=true&"
import script from "./CreateTenant.vue?vue&type=script&lang=js&"
export * from "./CreateTenant.vue?vue&type=script&lang=js&"
import style0 from "./CreateTenant.vue?vue&type=style&index=0&id=c03fa4e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03fa4e2",
  null
  
)

export default component.exports